import api from './api';
import { Assistance, AssistanceFormData } from '../types/Assistance';

const ENDPOINT = '/assistances/';

// Obtener todas las asistencias, opcionalmente con filtros
export const getAssistances = async (filters?: {
  search?: string;
  date_from?: string;
  date_to?: string;
  beneficiary?: number;
}) => {
  try {
    // Log para depuración
    console.log("[ASSISTANCES] baseURL:", api.defaults.baseURL, "ENDPOINT:", ENDPOINT, "filters:", filters);
    const response = await api.get<Assistance[]>(ENDPOINT, { params: filters });
    return response.data;
  } catch (error) {
    console.error('Error al obtener asistencias:', error);
    throw error;
  }
};

export const getAssistance = async (id: number) => {
  try {
    const response = await api.get<Assistance>(`${ENDPOINT}${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener asistencia ${id}:`, error);
    throw error;
  }
};

export const createAssistance = async (assistanceData: AssistanceFormData) => {
  try {
    const response = await api.post<Assistance>(ENDPOINT, assistanceData);
    return response.data;
  } catch (error) {
    console.error('Error al crear asistencia:', error);
    throw error;
  }
};

export const updateAssistance = async (id: number, assistanceData: AssistanceFormData) => {
  try {
    const response = await api.put<Assistance>(`${ENDPOINT}${id}/`, assistanceData);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar asistencia ${id}:`, error);
    throw error;
  }
};

export const deleteAssistance = async (id: number) => {
  try {
    await api.delete(`${ENDPOINT}${id}/`);
    return true;
  } catch (error) {
    console.error(`Error al eliminar asistencia ${id}:`, error);
    throw error;
  }
};

// Obtener asistencias por beneficiario
export const getAssistancesByBeneficiary = async (beneficiaryId: number): Promise<Assistance[]> => {
  try {
    return await getAssistances({ beneficiary: beneficiaryId });
  } catch (error) {
    console.error(`Error al obtener asistencias del beneficiario ${beneficiaryId}:`, error);
    throw error;
  }
};